export const LOCATION_CHECK = {
  init: function () {
    const menuSelector = '#menu-gnav'
    const path = location.pathname.split('/')
    const slug = path[1]

    if (slug) {
      const subPath = slug === 'article' && path[2] ? path[2] : ''
      $(`${menuSelector} a[href*="/${slug}${subPath}"]`).attr('aria-current', 'page')
    }
  },
}
